import { CircleNotch, FileArrowUp } from "@phosphor-icons/react";

/**
 * Full-screen modal overlay shown while a file is being uploaded and AI-extracted.
 * Blocks interaction so the user cannot double-submit.
 */
export default function UploadOverlay({ open, filename, kind }) {
    if (!open) return null;
    const title = kind === "bank" ? "Reading bank statement" : kind === "sales" ? "Reading sales invoice" : "Reading invoice";
    const sub = kind === "bank"
        ? "Parsing statement, deduplicating lines, and matching inter-bank transfers…"
        : "Extracting vendor, GST, HSN and line items with AI. This can take 5–15 seconds — please stay on this page.";
    return (
        <div
            className="fixed inset-0 z-50 grid place-items-center"
            style={{ background: "rgba(28, 25, 23, 0.55)", backdropFilter: "blur(4px)" }}
            data-testid="upload-overlay"
            role="dialog"
            aria-modal="true"
        >
            <div className="bg-white rounded-md shadow-lg p-8 max-w-md w-[90%] mx-4 relative overflow-hidden" style={{ border: "1px solid var(--se-border)" }}>
                <span className="absolute left-0 top-0 bottom-0 w-1" style={{ background: "linear-gradient(180deg, #d98a3f 0%, #8c3b20 100%)" }} />
                <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full grid place-items-center" style={{ background: "var(--se-brand-soft)" }}>
                        <CircleNotch size={26} weight="bold" className="animate-spin" style={{ color: "var(--se-brand)" }} />
                    </div>
                    <div className="flex-1">
                        <div className="font-serif text-xl" style={{ color: "var(--se-ink)" }}>{title}</div>
                        {filename ? (
                            <div className="text-xs text-stone-500 mt-0.5 flex items-center gap-1">
                                <FileArrowUp size={12} /> {filename}
                            </div>
                        ) : null}
                    </div>
                </div>
                <p className="text-sm text-stone-500 mt-4">{sub}</p>
                <div className="mt-4 h-1.5 rounded-full overflow-hidden" style={{ background: "var(--se-subtle)" }}>
                    <div className="h-full animate-pulse" style={{ background: "linear-gradient(90deg, #d98a3f 0%, #8c3b20 100%)", width: "60%" }} />
                </div>
            </div>
        </div>
    );
}
